<template>
  <div>
    <div
      v-if="!isDetailRoute"
      class="wrap-school-of-creativity"
    >
      <h2>School of Creativity I Creativity Day 2019</h2>
      <b-row class="section">
        <b-col
          v-for="section in sectionData"
          :key="section.id"
          cols="6"
          md="4"
          lg="3"
          class="content"
          :style="[ section.id === sessionId ? 'background: #F1F2F2' : {} ]"
          @click="clickSection(section.id)"
          v-scroll-to="'#sessionScroll'"
        >
          <img :src="section.imgUrl">
          <p>{{ section.description }}</p>
        </b-col>
      </b-row>

      <hr id="sessionScroll">

      <b-row class="session">
        <router-link
          v-for="session in sessionData"
          :key="session.id"
          :to="{
            name: 'creativity_school_of_creativity_detail',
            params: {
              mainId: sessionId,
              detailId: session.id
            }
          }"
        >
          <b-col
            cols="12"
            class="time"
          >
            <h3>{{ session.time_start }} - {{ session.time_end }} {{ session.name }}</h3>

            <div
              v-if="session.photo"
              class="personal"
            >
              <div
                v-for="photo in session.photo"
                :key="photo.id"
                class="text"
              >
                <p>{{ photo.name }}</p>
                <p>{{ photo.company }}</p>
              </div>
            </div>
          </b-col>
        </router-link>
      </b-row>
    </div>

    <SchoolOfCreativityDetail v-if="isDetailRoute"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const SchoolOfCreativityDetail = () => import('@/components/Creativity/SchoolOfCreativityDetail')

export default {
  components: {
    SchoolOfCreativityDetail
  },

  data () {
    return {
      sectionData: [],
      sessionId: 2,
      sessionData: []
    }
  },

  computed: {
    ...mapState({
      schoolCreativesRaw: state => state.creativity.schoolCreatives
    }),

    isDetailRoute () {
      if (this.$route.name === 'creativity_school_of_creativity_detail') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    mapSection (data) {
      this.sectionData = []

      data.forEach(schoolCreative => {
        const obj = {
          id: schoolCreative.id,
          imgUrl: `https://admanawards.com/storage/app/img/creativeDay/${schoolCreative.image}`,
          description: schoolCreative.description,
          detail: schoolCreative.detail
        }

        this.sectionData.push(obj)
      })
    },

    mapSession (id, data) {
      this.sessionData = []

      if (data) {
        data.forEach(schoolCreative => {
          if (id === schoolCreative.id) {
            schoolCreative.detail.forEach(detail => {
              this.sessionData.push(detail)
            })
          }
        })
      }
    },

    async clickSection (id) {
      this.sessionId = id

      this.mapSession(id, this.schoolCreativesRaw)

      // this.$refs.session.scrollIntoView({
      //   behavior: 'smooth'
      // })
    },

    clickDetail () {
      this.mapDetail(this.schoolCreativesRaw)
    }
  },

  watch: {
    schoolCreativesRaw (data) {
      if (data) {
        this.mapSection(data)
      }
    },

    sectionData (data) {
      if (data) {
        this.mapSession(this.sessionId, this.schoolCreativesRaw)
      }
    },

    schoolCreativeDetail (data) {
      this.mapDetail(data)
    }
  },

  created () {
    this.$store.dispatch('creativity/getSchoolCreativity')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-school-of-creativity {
  padding-bottom: 22px;

  h2 {
    padding: 22px 0;
    line-height: 1;
  }

  .section {
    margin-bottom: 22px;

    .content {
      cursor: pointer;
      padding-top: 12px;
      padding-bottom: 12px;

      img {
        width: 100%;
        height: auto;
        background-color: $light;
      }

      p {
        padding: 22px 0;
        line-height: 1;
        font-size: 1.25rem;
      }
    }
  }

  hr {
    margin: 44px 0;
    width: 100%;
    border: 0.25px solid #CCC;

    @media only screen and (min-width: $break-m) {
      margin: 62px 0;
    }
  }

  .session {
    a {
      margin-bottom: 12px;
      width: 100%;

      .time {
        padding-top: 8px;
        padding-bottom: 8px;
        background-color: $light;

        h3 {
          align-items: center;
          line-height: 1;
          font-size: 1.25rem;
          color: black;
        }

        .personal {
          margin-top: 6px;
          width: auto;
          display: flex;
          justify-content: flex-start;

          .text {
            margin-right: 22px;
            padding-left: 22px;
            border-left: 1px solid #CCC;

            p {
              margin-bottom: -8px;
            }

            p:last-child {
              margin-bottom: 0px;
              color: $dark;
            }
          }

          .text:first-child {
            padding-left: 0;
            border-left: none;
          }
        }
      }
    }
  }
}
</style>
